import axios from "axios";
export default {
    data() {
        return {
            charts: [],
            blankSpace: { name: "Blank space", id: -1 },
        }
    },
    methods: {
        async getCharts(chartsConfig,chartParams) { 
            
            await this.loadCharts(chartParams);

            let charts = [];
            for (const [key, value] of Object.entries(chartsConfig)) {
                var chart = this.findChart(value.chartId);
                if (this.isBlankSpace(chart)) {
                    charts.push({ id: chart.id, value: value.size, name: chart.name });
                } else {
                    charts.push(await this.setField(chart, value.size));
                }
            }
            return charts;
        },
        parseChartOptions(config) {
            var configParsed = JSON.parse(config);
            return configParsed.options;
        },
        async getServerChartData(id) {
            var data = (await axios.get("dashboards/" + id + "/data")).data;
            return data;
        },
        findChart(id) {
            var _chart = this.blankSpace;
            for (var chart in this.charts) {
                if (this.charts[chart].id == id) _chart = this.charts[chart];
            }
            return _chart;
        },
        isBlankSpace(chart) {
            return chart._Entity == null;
        },
        async setField(chart, size) {
            return {
                id: chart.id,
                value: size,
                name: chart.name,
                criterias: chart.criterias,
                criteriaDenied: chart.criteriaDenied,
                dimensionsCriterias: chart.dimensionsCriterias,
                _Entity: chart._Entity,
                options: this.parseChartOptions(chart.config),
                data: await this.getServerChartData(chart.id),
                type: chart.type
            };
        },
        async loadCharts(chartParams) {
            try {
                this.charts = (await axios.get("charts", {
                    params: {
                        load: ['DataSets','DataSets.Criterias','Dimensions'],
                        ...chartParams
                    }
                })).data.data;
                this.charts.push(this.blankSpace);
            } catch (error) {
                console.error(error);
            }
        },
    }
}